module.exports = __webpack_public_path__ + "img/slide1.4a4097c4.webp";